<template>
    <input @focus="inputFocus" @blur="inputBlur" @change="onChange" type="text" v-model="inputValue" />
</template>

<script>
    export default {
        name: "CashTextInput",
        model: {
            prop: "value",
            event: "change"
        },
        props: {
            value: [String, Number]
        },
        data: () => ({
            inputValue: "",
        }),
        mounted: function () {
            this.inputValue = this.value;
        },
        methods: {
            //输入框效果
            inputFocus: function(e){
                $(e.target).addClass("cur");
            },
            inputBlur: function(e){
                $(e.target).removeClass("cur");
            },
            onChange: function () {
                this.$emit("change", this.inputValue);
            }
        },
        watch: {
            value: function (d) {
                this.inputValue = d;
            },
        }
    }
</script>

<style scoped>
    input{
        text-align: center;
        border: none;
        background: transparent;
        padding: 4px 0px;
        /*height: 16px;*/
        width: 90%;
    }
    input:hover, input.cur{
        border: 1px solid #dddddd;
        background: #FFFFFF;
    }
</style>
